import type { FaireProductEntity } from "../../entity_types/product";

export const driftless_studios_9: FaireProductEntity = {
  token: "driftless-studios-9",
  type: "product",
  name: "Thanksgiving Turkey Waffle Tea Towel - Fall Decor",
  brandName: "Driftless Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/f4f64186ff07ab5706e82516e9708098e2856054cd74353bee94d570d8e008ff.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 8.5,
  msrpDollars: 16,
  freeShipping: true,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
